document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href^="#"]')
  if (link) {
    event.preventDefault()
    const selector = link.getAttribute('href')
    if (selector !== '#') {
      const target = document.querySelector(link.getAttribute('href'))
      if (target) {
        const headerHeight =
          parseInt(
            document.documentElement.style.getPropertyValue('--header-height')
          ) || 100
        window.scrollTo({
          top:
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight,
          behavior: 'smooth'
        })
      } else {
        console.warn(
          `Nowhere to scroll elements with selector: "${selector}" not found`
        )
      }
    }
  }
})
